import type { HttpErrorResponse } from '@angular/common/http';

import type { InterviewScheduleLink } from '@recruitee/interview-schedules-types';
import { createSingleEntityStore, ngrxEvent, pipeState } from '@recruitee/ngrx';

import { InterviewScheduleAssignmentsCollectionSelectors } from '../assignments-collection/assignments-collection.store';
import { BriefInterviewScheduleResultRequestsCollectionSelectors } from '../result-requests-collection/brief-result-requests-collection.store';

const { actions, selectors, reducer, namespace } = createSingleEntityStore<InterviewScheduleLink>()(
  'InterviewSchedulesLinkEntity',
  {
    references: makeRef => [
      makeRef(
        'interviewScheduleAssignmentsIds',
        'interviewScheduleAssignments',
        InterviewScheduleAssignmentsCollectionSelectors.byIds,
      ),
      makeRef(
        'interviewScheduleResultRequestsIds',
        'interviewScheduleResultRequests',
        BriefInterviewScheduleResultRequestsCollectionSelectors.byIds,
      ),
    ],
    customActions: adapter => ({
      fetch: (state, payload: { id: number }) => adapter.markAsPending(state),

      delete: (state, payload: { id: number }) => adapter.markAsPending(state),
      deleteSuccess: (state, payload: InterviewScheduleLink) =>
        pipeState(state, next => adapter.markAsLoaded(next)),
      deleteFailed: (state, payload: HttpErrorResponse) => adapter.setError(state, payload),
      fetchDuplicateName: (state, payload: { id: number }) => state,
      fetchDuplicateNameSuccess: ngrxEvent<string>(),
    }),
  },
);

export {
  actions as InterviewSchedulesLinkEntityActions,
  selectors as InterviewSchedulesLinkEntitySelectors,
  reducer as InterviewSchedulesLinkEntityReducer,
  namespace as InterviewSchedulesLinkEntityNamespace,
};
